import type { SyntheticEvent } from "react";

/** Shown when a recipe has no image (or its image fails to load). */
export const RECIPE_PLACEHOLDER_IMAGE = "/images/recipe-placeholder.svg";

/** `onError` handler: swap a broken recipe image for the placeholder (once, no loop). */
export function fallbackToRecipePlaceholder(
  e: SyntheticEvent<HTMLImageElement>
) {
  const img = e.currentTarget;
  if (!img.src.endsWith(RECIPE_PLACEHOLDER_IMAGE)) {
    img.src = RECIPE_PLACEHOLDER_IMAGE;
  }
}
